import { render, staticRenderFns } from "./homeProjects.vue?vue&type=template&id=3d6702a0&scoped=true&"
import script from "./homeProjects.vue?vue&type=script&lang=js&"
export * from "./homeProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6702a0",
  null
  
)

export default component.exports